const Xuc = {
  symbol: 'xuc',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }"  d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm11-16c0-6.075-4.925-11-11-11S5 9.924 5 16c0 6.075 4.925 11 11 11s11-4.925 11-11zm-3.77.346l-12.318.017a5.094 5.094 0 0 0 5.077 4.726 5.08 5.08 0 0 0 4.48-2.686h2.322a7.23 7.23 0 0 1-5.44 4.681v1.446l-2.24.698V23.16c-3.574-.435-6.345-3.474-6.345-7.165 0-3.605 2.647-6.587 6.103-7.125V7.467l2.239-.697v2.1c3.457.538 6.122 3.742 6.122 7.35 0 .126.007 0 0 .126zM11.25 14.13h9.477a5.095 5.095 0 0 0-4.738-3.229 5.093 5.093 0 0 0-4.738 3.23z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#25AAE3"/><path fill="#FFF" d="M27 16c0 6.075-4.925 11-11 11S5 22.075 5 16C5 9.924 9.925 5 16 5s11 4.925 11 11zm-3.77.346c.007-.125 0 0 0-.127 0-3.607-2.665-6.811-6.122-7.35v-2.1l-2.24.698V8.87c-3.455.538-6.102 3.52-6.102 7.125 0 3.69 2.77 6.73 6.344 7.165v2.068l2.24-.698v-1.446a7.23 7.23 0 0 0 5.441-4.68H20.47a5.08 5.08 0 0 1-4.48 2.685 5.094 5.094 0 0 1-5.077-4.726l12.318-.017zM11.25 14.13a5.093 5.093 0 0 1 4.74-3.229 5.095 5.095 0 0 1 4.737 3.23h-9.476z"/></g>`;
  }
};
export default Xuc;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/xuc.js
// module id = null
// module chunks = 